import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import ModuleContainer from '../../components/cms/module-container'
import {Box, Text, useSlotRecipe} from '@chakra-ui/react3'
import awardsSlotRecipe from './index.recipe'
import Image from '../../components/cms/image'
import Heading from '../../components/cms/heading'
import TypewrighterAnimation from '../../components/cms/typewriterAnimation'

const Awards = ({anchor, headingLevel, heading, copy, background, images}) => {
    const recipe = useSlotRecipe({recipe: awardsSlotRecipe})
    const styles = useMemo(() => recipe(), [recipe])

    return (
        <ModuleContainer anchor={anchor} background={background} css={styles.root}>
            <Heading
                {...heading}
                variant="small"
                headingLevel={headingLevel}
                alignment="center"
            ></Heading>
            <TypewrighterAnimation from={'text.secondary'} to={'text.primary'} css={styles.copy}>
                {copy.text}
            </TypewrighterAnimation>
            {images?.length > 0 && (
                <Box css={styles.awardsGroup}>
                    {images.map((el, index) => (
                        <Box key={index} css={styles.award}>
                            <Image
                                {...el}
                                css={styles.awardImage}
                                widths={{
                                    base: '28.8vw',
                                    s: '9.7vw'
                                }}
                            ></Image>
                            <Text css={styles.awardText}>{el.title}</Text>
                        </Box>
                    ))}
                </Box>
            )}
        </ModuleContainer>
    )
}

Awards.propTypes = {
    anchor: PropTypes.string,
    headingLevel: PropTypes.number,
    heading: PropTypes.object,
    copy: PropTypes.object,
    background: PropTypes.oneOf(['default', 'subtle', 'strong', 'inverse']),
    images: PropTypes.array
}

export default Awards
